import { useState } from "react";
import axios from "axios";
import { EnvelopeSimple, ArrowRight, ShieldCheck, CircleNotch } from "@phosphor-icons/react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
const SUCCESS_MSG =
  "Thank you. An authorised Air12 representative will contact you shortly to begin your Air12 onboarding.";

// Interim-only right-hand panel shown on `/`. Email-only Priority Access interest → persisted as a
// normal lead via POST /api/public/priority-onboarding (server sets provenance/reason).
export default function PriorityAccessPanel() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError("");
    const normalized = email.trim().toLowerCase();
    if (!EMAIL_RE.test(normalized)) { setError("Enter a valid email address."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/public/priority-onboarding`, { requester_email: normalized });
      setDone(true);
    } catch {
      setError("Something went wrong. Please try again in a moment.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="w-full max-w-sm" data-testid="priority-access-panel">
      <div className="overline mb-2">PRIORITY ACCESS</div>
      <h2 className="heading text-2xl mb-1 tracking-tight">Get onboarded with Air12</h2>
      <p className="text-sm text-[hsl(var(--muted))] mb-7">
        Leave your email and an authorised Air12 representative will reach out to begin your priority onboarding.
      </p>

      {done ? (
        <p className="text-sm text-[hsl(var(--accent))] flex items-start gap-2" data-testid="priority-access-success">
          <ShieldCheck size={16} weight="bold" className="mt-0.5 shrink-0" />
          {SUCCESS_MSG}
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-3" data-testid="priority-access-form">
          <label className="block">
            <div className="overline mb-1.5">EMAIL</div>
            <input
              type="email"
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              placeholder="you@company.com"
              data-testid="priority-access-email"
            />
          </label>
          {error && <p className="text-sm text-[hsl(var(--destructive))]" data-testid="priority-access-error">{error}</p>}
          <button type="submit" className="btn-primary w-full justify-center mt-2" disabled={busy} data-testid="priority-access-submit">
            {busy ? (<><CircleNotch size={14} weight="bold" className="animate-spin" /> Submitting…</>) : (<><EnvelopeSimple size={14} weight="bold" /> Request Priority Access <ArrowRight size={14} weight="bold" /></>)}
          </button>
          <p className="text-xs text-[hsl(var(--muted))] leading-relaxed">
            No account needed. Air12 will contact you to begin onboarding.
          </p>
        </form>
      )}
    </div>
  );
}
